import { useTranslation } from "react-i18next";
import { useProjects } from "../../../projects/projectContext";
import Chip from "../../../ui/feedback/Chip";
import { waitingCount } from "./inboxCounts";
import { useReviewInbox } from "./useReviewInbox";

/**
 * How much waits for the user to answer, on the Threads tab, counted from the same snapshot
 * the sidebar's "Waiting for you" shows (ADR-0031 D4, F108).
 */
export default function ReviewInboxBadge() {
  const { t } = useTranslation();
  const state = useReviewInbox(useProjects().selectedProjectId);
  const count = state?.status === "loaded" ? waitingCount(state.value) : 0;
  if (count === 0) {
    return null;
  }
  return (
    <Chip tone="info" size="compact" title={t("reviews.collaboration.inbox.badge", { count })} className="ml-1.5 font-semibold">
      {count}
      <span className="sr-only">{t("reviews.collaboration.inbox.badge", { count })}</span>
    </Chip>
  );
}
